(() => {
  const routeRoot = () => {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const cartLink = () => document.querySelector('[data-nuvia-cart-link]');

  const setCartCount = async ({ bump = false } = {}) => {
    const response = await fetch(`${routeRoot()}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) return null;

    const cart = await response.json();
    document.querySelectorAll('[data-nuvia-cart-link]').forEach((link) => {
      const count = link.querySelector('[data-nuvia-cart-count]');
      link.classList.toggle('has-items', cart.item_count > 0);
      link.setAttribute('aria-label', cart.item_count > 0 ? `購物車，目前 ${cart.item_count} 件商品` : '購物車');

      if (count) {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      }

      if (bump) {
        link.classList.remove('is-bumped');
        window.requestAnimationFrame(() => {
          link.classList.add('is-bumped');
          window.setTimeout(() => link.classList.remove('is-bumped'), 520);
        });
      }
    });

    return cart;
  };

  const showStatus = (form, message, type = 'success') => {
    const status = form.querySelector('[data-nuvia-cart-status]');
    if (!status) return;
    status.textContent = message;
    status.hidden = !message;
    status.classList.toggle('is-error', type === 'error');
  };

  const productImageUrl = (form) => {
    const productShell = form.closest('.product-shell');
    const image = productShell
      ? productShell.querySelector('.product-gallery-slide.is-active img, .product-gallery img')
      : null;
    return image ? (image.currentSrc || image.src || '') : '';
  };

  const flyToCart = (form, sourceElement) => new Promise((resolve) => {
    const target = cartLink();
    const source = sourceElement || form;

    if (
      !target ||
      !source ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      resolve(false);
      return;
    }

    const start = source.getBoundingClientRect();
    const targetAnchor = target.querySelector('.cart-icon') || target;
    const end = targetAnchor.getBoundingClientRect();
    if (!start.width || !start.height || !end.width || !end.height) {
      resolve(false);
      return;
    }

    const size = Math.min(58, Math.max(46, Math.round(Math.min(start.width, 72))));
    const startX = start.left + start.width / 2;
    const startY = start.top + start.height / 2;
    const endX = end.left + end.width / 2;
    const endY = end.top + end.height / 2;

    const flyer = document.createElement('div');
    flyer.className = 'cart-flyer';
    flyer.setAttribute('aria-hidden', 'true');
    flyer.style.width = `${size}px`;
    flyer.style.height = `${size}px`;
    flyer.style.left = `${startX - size / 2}px`;
    flyer.style.top = `${startY - size / 2}px`;

    const imageUrl = productImageUrl(form);
    if (imageUrl) {
      flyer.style.backgroundImage = `url("${imageUrl}")`;
    }

    document.body.appendChild(flyer);

    const moveX = endX - startX;
    const moveY = endY - startY;
    const lift = Math.min(120, Math.max(70, Math.abs(moveY) * 0.22));

    if (typeof flyer.animate !== 'function') {
      window.setTimeout(() => {
        flyer.remove();
        resolve(true);
      }, 520);
      return;
    }

    const animation = flyer.animate([
      {
        transform: 'translate3d(0, 0, 0) scale(.86) rotate(0deg)',
        opacity: 0
      },
      {
        transform: 'translate3d(0, -8px, 0) scale(1) rotate(0deg)',
        opacity: 1,
        offset: .12
      },
      {
        transform: `translate3d(${moveX * .42}px, ${moveY * .44 - lift}px, 0) scale(.86) rotate(-3deg)`,
        opacity: .98,
        offset: .56
      },
      {
        transform: `translate3d(${moveX * .84}px, ${moveY * .84 - 14}px, 0) scale(.42) rotate(-1deg)`,
        opacity: .9,
        offset: .86
      },
      {
        transform: `translate3d(${moveX}px, ${moveY}px, 0) scale(.12) rotate(0deg)`,
        opacity: 0
      }
    ], {
      duration: 920,
      easing: 'cubic-bezier(.18, .72, .18, 1)'
    });

    const cleanup = () => {
      flyer.remove();
      resolve(true);
    };

    animation.addEventListener('finish', cleanup, { once: true });
    animation.addEventListener('cancel', cleanup, { once: true });
  });

  const syncProductSizeState = (form) => {
    const sizeSelector = form.querySelector('[data-nuvia-size-selector]');
    if (!sizeSelector) return true;

    const selectedOption = sizeSelector.options[sizeSelector.selectedIndex];
    const hasSelection = Boolean(sizeSelector.value);
    const isSoldOut = Boolean(
      hasSelection &&
      selectedOption &&
      selectedOption.dataset.nuviaVariantAvailable === 'false'
    );
    const canSubmit = hasSelection && !isSoldOut;
    const primaryButton = form.querySelector('.product-submit');
    const buyNowButton = form.querySelector('[data-nuvia-buy-now]');
    const stickySubmit = form.querySelector('.product-mobile-sticky-submit');

    [primaryButton, buyNowButton, stickySubmit].forEach((button) => {
      if (button) button.disabled = !canSubmit;
    });

    if (stickySubmit) {
      if (!hasSelection) {
        stickySubmit.textContent = '請先選擇尺寸';
      } else if (isSoldOut) {
        stickySubmit.textContent = '此尺寸已售完';
      } else {
        stickySubmit.textContent = '加入購物車';
      }
    }

    return canSubmit;
  };

  document.querySelectorAll('[data-nuvia-product-form]').forEach((form) => {
    const sizeSelector = form.querySelector('[data-nuvia-size-selector]');
    if (!sizeSelector) return;

    syncProductSizeState(form);
    sizeSelector.addEventListener('change', () => {
      syncProductSizeState(form);
      showStatus(form, '');
    });
  });

  const initBackToTopVisibility = () => {
    const backToTop = document.querySelector('[data-nuvia-back-to-top]');
    if (!backToTop) return;

    const mobileQuery = window.matchMedia('(max-width: 760px)');
    const syncVisibility = () => {
      const visible = !mobileQuery.matches || window.scrollY > Math.max(window.innerHeight * 1.15, 820);
      backToTop.classList.toggle('is-visible', visible);
      backToTop.setAttribute('aria-hidden', visible ? 'false' : 'true');
      backToTop.tabIndex = visible ? 0 : -1;
    };

    syncVisibility();
    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility);
  };

  initBackToTopVisibility();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-nuvia-product-form]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!syncProductSizeState(form)) {
      const sizeSelector = form.querySelector('[data-nuvia-size-selector]');
      showStatus(form, '請先選擇尺寸。', 'error');
      if (sizeSelector) {
        sizeSelector.scrollIntoView({ block: 'center', behavior: 'smooth' });
        window.setTimeout(() => sizeSelector.focus({ preventScroll: true }), 260);
      }
      return;
    }

    const submitter = event.submitter || form.querySelector('[type="submit"]');
    if (!submitter || submitter.disabled) return;

    const buttons = Array.from(form.querySelectorAll('[type="submit"]'));
    const isBuyNow = submitter.matches('[data-nuvia-buy-now]');
    const defaultText = submitter.textContent.trim();

    buttons.forEach((button) => {
      button.disabled = true;
    });
    submitter.classList.add('is-loading');
    submitter.textContent = isBuyNow ? '前往結帳中...' : '加入中...';
    showStatus(form, '');

    try {
      const response = await fetch(`${routeRoot()}cart/add.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Add to cart failed');

      await flyToCart(form, submitter);
      await setCartCount({ bump: true });

      if (isBuyNow) {
        showStatus(form, '已加入購物車，正在前往結帳。');
        window.setTimeout(() => window.location.assign(`${routeRoot()}checkout`), 220);
        return;
      }

      submitter.textContent = '已加入';
      showStatus(form, '已加入購物車，可以繼續挑選或前往購物車結帳。');
      window.setTimeout(() => {
        submitter.textContent = defaultText || '加入購物車';
        syncProductSizeState(form);
      }, 1800);
    } catch (error) {
      submitter.textContent = defaultText || '加入購物車';
      showStatus(form, '加入失敗，請再試一次。', 'error');
    } finally {
      submitter.classList.remove('is-loading');
      buttons.forEach((button) => {
        button.disabled = false;
      });
      syncProductSizeState(form);
    }
  }, true);
})();
